"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var PromoCard_1 = require("./PromoCard");
exports.default = PromoCard_1.default;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/cart-ui/components/panels/PromoPanel/PromoCard/index.js
// module id = 2389
// module chunks = 8